<template>
  <div uk-height-viewport="expand: true">
    <div id="overlay">
    </div>
    <img :src="idLogo" class="uk-position-top-left">
    <img :src="idFooter" class="uk-position-bottom-left">
  </div>
</template>

<script>
  import * as misc from '../../../enums/misc'
  import iconUtil from '../../../utils/icon-util'
  import screen from '../../../utils/screen-util'

  export default {
    name: 'IdLoginBackground',
    data() {
      return {
        screenWidth: 0
      }
    },
    computed: {
      idLogo() {
        return iconUtil.resolve(misc.ID_SMART_LOGO)
      },
      idFooter() {
        return iconUtil.resolve(misc.ID_FOOTER)
      }
    },
    methods: {
      resolveWindowWidth() {
        this.screenWidth = screen.resolveWidth()
      }
    },
    created() {
      this.resolveWindowWidth()
      window
        .addEventListener(
          'resize',
          this.resolveWindowWidth)
    },
    destroyed() {
      window
        .removeEventListener(
          'resize',
          this.resolveWindowWidth)
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';

  .background-img {
    background-image: -webkit-linear-gradient(left, rgb(21, 155, 217), rgb(51, 107, 179));
  }

  .uk-position-top-left {
    top: 20px;
    left: 20px;
  }

  .uk-position-bottom-left{
    bottom: 40px;
    left: 20px;
  }

  #overlay {
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.65); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  }
</style>
